export default __webpack_public_path__ + "static/popupCover-eced2fbd8b6a36cbae763eb0925bec97.png";